<div class="page">
  <div class="title-btn-container">
    <div class="title">{{ 'store.products.title' | translate }}</div>
    <div class="btns-container">
      <button (click)="createNewProduct(-1)">
        <img src="assets/images/add-btn.png" alt="">
        {{ 'store.products.create' | translate }}
      </button>
    </div>
  </div>
  <div class="vouchers-filters-container">
    <div class="inputs-container">
      <div style="display: flex;align-content: center;">
        <div style="font-size: 12px ;display: flex;align-items: center">
          {{ 'store.products.categoriesLabel' | translate }}
        </div>
        <app-select style="margin-inline-start: 5px; width: 100%; max-width: 200px;" [selectedItem]="params.categoryId"
          [options]="categoriesList" (changeSelect)="changeFilter($event)"></app-select>
      </div>
      <div class="search-container">
        <img src="assets/images/search.svg">
        <input [(ngModel)]="params.search" (keyup.enter)="doSearchByEnter($event);" (keyup)="doSearchByKeyUp($event);"
          [placeholder]="'store.products.searchPlaceholder' | translate" type="text">
      </div>
    </div>
  </div>
  <div class="mobile-only mobile-table" *ngIf="dataList?.length">
    <div class="mobile-table__card" *ngFor="let item of dataList; let i = index">
      <div class="mobile-table__header">
        <div>
          <div class="mobile-table__title">{{item.name}}</div>
          <div  class="mobile-table__meta"><span class="ltr-text">{{item.createdDate | date: 'hh:mm, d MMMM y' }}</span></div>
        </div>
        <div class="mobile-table__actions">
          <button
            class="mobile-table__action-btn"
            [placement]="'bottom'"
            [outsideClick]="true"
            #pop="bs-popover"
            [popover]="popTemplateMobile"
            [attr.aria-label]="'common.actions' | translate"
          >
            <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
          </button>
          <ng-template #popTemplateMobile>
            <div class="mobile-table__menu-item mobile-table__menu-item--divider"
              (click)="goToDetails(item)">
              {{ 'store.products.edit' | translate }}
            </div>
            <div class="mobile-table__menu-item" (click)="openConfirmDialog(item)" data-bs-toggle="modal"
              data-bs-target="#confirmModal">
              {{ 'store.products.delete' | translate }}
            </div>
          </ng-template>
        </div>
      </div>
      <div class="mobile-table__rows">
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'common.description' | translate }}</div>
          <div class="mobile-table__value mobile-description-clamp">{{item.description}}</div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.products.table.price' | translate }}</div>
          <div class="mobile-table__value">{{item.price}}</div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.settings.category' | translate }}</div>
          <div class="mobile-table__value">{{item.productCategory?.name}}</div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.products.table.available' | translate }}</div>
          <div class="mobile-table__value">{{item.availableQuantity}}</div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.products.table.updated' | translate }}</div>
          <div  class="mobile-table__value"><span class="ltr-text">{{item.updatedDate | date: 'hh:mm, d MMMM y' }}</span></div>
        </div>
      </div>
    </div>
  </div>
  <div class="empty-list mobile-only" *ngIf="!dataList?.length">{{ 'store.products.empty' | translate }}</div>
  <div class="table-wrapper desktop-only">
    <table class="table AgentsTable">
      <thead>
        <tr>
          <th>{{ 'store.products.table.name' | translate }}</th>
          <th>{{ 'common.description' | translate }}</th>
          <th>{{ 'store.products.table.price' | translate }}</th>
          <th>{{ 'store.products.table.categoryName' | translate }}</th>
          <th>{{ 'store.products.table.availableQuantity' | translate }}</th>
          <th>{{ 'store.products.table.createdDate' | translate }}</th>
          <th>{{ 'store.products.table.updatedDate' | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of dataList; let i = index">
          <td>
            {{item.name}}
          </td>
          <td class="description-cell" [title]="item.description">
            <span class="description-text">{{item.description}}</span>
          </td>
          <td>{{item.price}}</td>
          <td>{{item.productCategory?.name}}</td>
          <td>{{item.availableQuantity}}</td>
          <td ><span class="ltr-text">{{item.createdDate | date: 'hh:mm, d MMMM y' }}</span></td>
          <td ><span class="ltr-text">{{item.updatedDate | date: 'hh:mm, d MMMM y' }}</span></td>

          <td class="dots-container">
            <button [placement]="'left'" [outsideClick]="true" #pop="bs-popover" [popover]="popTemplate">
              <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
            </button>

            <ng-template #popTemplate>
              <div class="mobile-table__menu-item mobile-table__menu-item--divider"
                (click)="goToDetails(item)">
                {{ 'store.products.edit' | translate }}
              </div>
              <div class="mobile-table__menu-item" (click)="openConfirmDialog(item)"  data-bs-toggle="modal"
              data-bs-target="#confirmModal"> {{ 'store.products.delete' | translate }}
              </div>
            </ng-template>
          </td>
        </tr>
      </tbody>

    </table>
    <div class="empty-list" *ngIf="!dataList?.length">{{ 'store.products.empty' | translate }}</div>

  </div>
  <div class="table-footer">
    <app-pagination [totalPages]="totalPages" [currentPage]="params?.page" (backClicked)="backClick($event)"
      (nextClicked)="nextClick($event)"></app-pagination>
    <!-- <app-export-csv [disabled]="!dataList?.length" path="web/vouchers/csv" [params]="params"></app-export-csv> -->
  </div>
  <ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
</div>

<app-confirm-dialog [itemName]="selectedItemName" (onConfirm)="deleteItem()"></app-confirm-dialog>
